module.exports = __webpack_public_path__ + "static/media/18ECA28.856f01de.jpg";